<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="政策法规管理"
        name="/operate/policy/statute"
      ></el-tab-pane>
    </el-tabs>
    <router-view />
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  setup() {
    let activeName = ref("/operate/policy/statute");
    return { activeName };
  },
};
</script>

<style>
</style>